// @flow
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import type { CablePath } from 'esm-web-pro/types/networks';
import PermitDocument from 'esm-web-pro/components/pages/network/PermitDocument';
import cableAndFiberMessages from 'esm-web-pro/messages/cableAndFiberMessages';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';
import { isEmpty } from 'lodash';


type Props = {
    cablePaths: CablePath[],
    reload: Function,
};

const CablePathsPermitDocuments = (props: Props) => {
    const { cablePaths, reload } = props;
    const { formatMessage } = useIntl();

    let renderPermitDocuments = [];
    if (!isEmpty(cablePaths)) {
        renderPermitDocuments = cablePaths.filter((cablePath) => {
            const { permit_documents: permitDocuments } = cablePath;
            return !isEmpty(permitDocuments);
        }).map((cablePath: CablePath) => {
            const {
                permit_documents: permitDocuments,
                sequence_number: pathSequence,
                provider_ref: providerRef,
            } = cablePath;

            let title = `${formatMessage(cableAndFiberMessages.cablePath)} ${pathSequence}`;
            if (providerRef) {
                title += ` ${providerRef}`;
            }

            return permitDocuments.map((permitDocument) => {
                const { sequence_number: documentSequence } = permitDocument;

                return (
                    <PermitDocument
                        document={permitDocument}
                        key={`${pathSequence}-${documentSequence}`}
                        buildName={(documentName) => `${title} - ${documentName}`}
                        reload={reload}
                    />
                );
            });
        });
    }

    return !isEmpty(renderPermitDocuments) ? renderPermitDocuments : (
        <ContentRow padLevel={1}>
            <ValueText>
                <FormattedMessage id="no-permit-documents" defaultMessage="No permit documents" />
            </ValueText>
        </ContentRow>
    );
};

export default CablePathsPermitDocuments;
